import React, { ReactElement } from "react";
import Loading from "../../../../ui-components/loading/loading";
import Legend from "../../../../ui-components/molecules/legend/legend";

interface HeadingTypeTileContentProps {
    isLoading: boolean;
    title: string;
    value: string | number | ReactElement;
    legendDescription?: string;
    onApply?: any
}

export const HeadingTypeTileContent: React.FC<HeadingTypeTileContentProps> = (props) => {
    return (
        <div className="content__heading">
            <div
                className="content__heading__values"
            >
                <div className="content__heading__values__heading">
                    {props.isLoading ?
                        <Loading isLoading={true} /> :
                        <div className="content__heading__values__heading__info">
                            {props.value}
                        </div>
                    }
                    <div className="content__heading__values__heading__title">
                        {props.title}
                    </div>
                </div>
            </div>
            <div className="content__heading__action">
                {!!props.legendDescription && <Legend>
                    <>{props.legendDescription}
                    </>
                </Legend>
                }
                {(!!props.onApply && !props.isLoading) && <div
                    className="content__heading__action__apply-btn"
                    onClick={() => props.onApply()}
                >Apply
                </div>
                }
            </div>
        </div>
    )
};